import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgPivotTable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M63.9956 21.3322V5.11885C63.9956 2.29116 61.7033 -0.00114441 58.8756 -0.00114441H5.1156C2.28791 -0.00114441 -0.00439453 2.29116 -0.00439453 5.11885V21.3322H63.9956Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.8756 63.9987C61.7033 63.9987 63.9956 61.7064 63.9956 58.8787V21.3322L19.1956 21.3321V58.8787C19.1956 61.7064 21.4879 63.9987 24.3156 63.9987H58.8756Z",
			fill: "#E3EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M-0.00439453 21.3322L19.1956 21.3321L19.1956 63.9988H5.11561C2.28791 63.9988 -0.00439453 61.7065 -0.00439453 58.8788L-0.00439453 21.3322Z",
			fill: "#BFDBFE"
		})
	]
});
export default SvgPivotTable;
